export const createGameTradeSlice = ({ sendUpdateTradeResponse, onClickExecuteTrade, onClickCreateTrade, onClickToggleEmbargoAgainstPlayer, sendCancelAction })=>(set, get)=>({
            gameTrade: {
                wantedCards: [],
                setWantedCards: (wantedCards)=>set({
                        gameTrade: {
                            ...get().gameTrade,
                            wantedCards: wantedCards
                        }
                    }),
                isShowTradePanel: false,
                setIsShowTradePanel: (isShowTradePanel)=>{
                    get().gameBeginnerHint.setBeginnerHintType(undefined);
                    if (isShowTradePanel) {
                        sendCancelAction();
                        get().actionBox.hideActionBox();
                    }
                    const playOrder = get().gameDetails.playOrder;
                    const is1v1 = playOrder.length === 2;
                    const hasCounterOffer = get().gameTrade.counterOffer != undefined;
                    const shouldBankTradeModeBeToggledByDefault = is1v1 && !hasCounterOffer;
                    if (shouldBankTradeModeBeToggledByDefault) {
                        set({
                            gameTrade: {
                                ...get().gameTrade,
                                isBankTradeMode: true
                            }
                        });
                    }
                    set({
                        gameTrade: {
                            ...get().gameTrade,
                            isShowTradePanel: isShowTradePanel,
                            counterOffer: !isShowTradePanel ? undefined : get().gameTrade.counterOffer
                        }
                    });
                },
                isBankTradeMode: false,
                setIsBankTradeMode: (isBankTradeMode)=>set({
                        gameTrade: {
                            ...get().gameTrade,
                            isBankTradeMode: isBankTradeMode
                        }
                    }),
                tradeError: undefined,
                setTradeError: (tradeError)=>{
                    const state = get();
                    if (state.gameTrade._tradeErrorTimeoutRef != null) {
                        clearTimeout(state.gameTrade._tradeErrorTimeoutRef);
                        set({
                            gameTrade: {
                                ...get().gameTrade,
                                _tradeErrorTimeoutRef: null
                            }
                        });
                    }
                    set({
                        gameTrade: {
                            ...get().gameTrade,
                            tradeError: tradeError
                        }
                    });
                    if (tradeError) {
                        const timeoutId = setTimeout(()=>{
                            set({
                                gameTrade: {
                                    ...get().gameTrade,
                                    tradeError: undefined,
                                    _tradeErrorTimeoutRef: null
                                }
                            });
                        }, 1000);
                        set({
                            gameTrade: {
                                ...get().gameTrade,
                                _tradeErrorTimeoutRef: timeoutId
                            }
                        });
                    }
                },
                _tradeErrorTimeoutRef: null,
                counterOffer: undefined,
                setCounterOffer: (counterOffer)=>set({
                        gameTrade: {
                            ...get().gameTrade,
                            counterOffer: counterOffer,
                            isBankTradeMode: false
                        }
                    }),
                onClickCreateTrade: onClickCreateTrade,
                onClickToggleEmbargoAgainstPlayer: onClickToggleEmbargoAgainstPlayer
            },
            gameTradeOffers: {
                sendUpdateTradeResponse: sendUpdateTradeResponse,
                onClickExecuteTrade: onClickExecuteTrade,
                isTradeOffersVisible: true,
                setIsTradeOffersVisible: (isTradeOffersVisible)=>set({
                        gameTradeOffers: {
                            ...get().gameTradeOffers,
                            isTradeOffersVisible: isTradeOffersVisible
                        }
                    })
            }
        });
